import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import StoreContextProvider from './Context/StoreContext'
import MultiCartContextProvider from './Context/MultiCartContext'
import { AuthProvider } from './Context/AuthContext'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>
      <StoreContextProvider>
        <MultiCartContextProvider>
          <App />
        </MultiCartContextProvider>
      </StoreContextProvider>
    </AuthProvider>
  </BrowserRouter>,
)
